export default function IconNotSmallScreens(props: Icon) {
  const { height, width } = props;
  return (
    <svg
      aria-hidden="true"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height : 78.8}
      height={height ? height : width ? width : 82.607}
      viewBox="0 0 78.8 82.607"
    >
      <g transform="translate(-9.85 -7.572)">
        <path
          d="M9.85,50.78a39.4,39.4,0,1,0,39.4-39.4,39.4,39.4,0,0,0-39.4,39.4Z"
          fill="#f7f4f1"
        />
        <path
          d="M62.822,82.278C62.822,81.019,56.7,80,49.14,80s-13.68,1.021-13.68,2.28,6.127,2.28,13.684,2.28S62.822,83.538,62.822,82.278Z"
          fill="rgba(105,19,45,0.33)"
        />
        <path
          d="M64.973,77.27a4.406,4.406,0,0,1-4.408,4.407H37.714a4.406,4.406,0,0,1-4.407-4.408V28.256a4.405,4.405,0,0,1,4.408-4.406H60.566a4.408,4.408,0,0,1,4.407,4.406Z"
          fill="#fff"
        />
        <path
          d="M37.714,82.427a5.156,5.156,0,0,1-5.157-5.158V28.256A5.161,5.161,0,0,1,37.712,23.1H60.566a5.164,5.164,0,0,1,5.157,5.156V77.27a5.162,5.162,0,0,1-5.156,5.157Zm0-57.827a3.66,3.66,0,0,0-3.658,3.656V77.269a3.656,3.656,0,0,0,3.657,3.658H60.565a3.661,3.661,0,0,0,3.658-3.657V28.256A3.662,3.662,0,0,0,60.566,24.6Z"
          fill="#2c0313"
        />
        <path
          d="M36.059,32.11H62.219V72.727H36.059Z"
          fill="rgba(105,19,45,0.33)"
        />
        <path
          d="M36.059,31.36H62.22a.75.75,0,0,1,.75.75V72.727a.75.75,0,0,1-.75.75H36.059a.75.75,0,0,1-.75-.75V32.11A.75.75,0,0,1,36.059,31.36Zm25.411,1.5H36.809V71.977H61.47Z"
          fill="#2c0313"
        />
        <path
          d="M55.335,28.73H47.762a.75.75,0,0,1,0-1.5h7.574a.75.75,0,0,1,0,1.5Z"
          fill="#2c0313"
        />
        <path
          d="M44.487,27.98a.853.853,0,1,1-.249-.606.855.855,0,0,1,.249.606Z"
          fill="#2c0313"
        />
        <path
          d="M46.73,77.2a2.409,2.409,0,1,0,2.409-2.409A2.409,2.409,0,0,0,46.73,77.2Z"
          fill="#fff"
        />
        <path
          d="M49.14,74.043A3.159,3.159,0,1,1,45.98,77.2,3.163,3.163,0,0,1,49.14,74.043Zm0,4.819A1.659,1.659,0,1,0,47.48,77.2,1.661,1.661,0,0,0,49.14,78.862Z"
          fill="#2c0313"
        />
        <path
          d="M51.31,38.537a2.178,2.178,0,0,1-1.922-3.2L63.178,9.474a2.178,2.178,0,0,1,3.841,0l13.79,25.861a2.178,2.178,0,0,1-1.911,3.2Z"
          fill="#fff"
        />
        <path
          d="M78.9,39.287H51.31a2.928,2.928,0,0,1-2.584-4.305L62.516,9.121a2.928,2.928,0,0,1,5.165,0l13.79,25.862A2.928,2.928,0,0,1,78.9,39.287ZM65.1,9.072a1.425,1.425,0,0,0-1.259.755L50.05,35.688a1.428,1.428,0,0,0,1.26,2.1H78.9a1.428,1.428,0,0,0,1.251-2.1L66.358,9.827A1.425,1.425,0,0,0,65.1,9.072Z"
          fill="#2c0313"
        />
        <path
          d="M65.982,28.16a.908.908,0,0,1-1.76,0c-2.308-9.095-2.149-8.456-2.157-8.552a3.053,3.053,0,1,1,6.075,0c-.009.092.152-.55-2.158,8.552Z"
          fill="#992058"
        />
        <path
          d="M67.473,32.737A2.372,2.372,0,1,1,65.1,30.366,2.372,2.372,0,0,1,67.473,32.737Z"
          fill="#992058"
        />
      </g>
    </svg>
  );
}
